import {
  IsMobilePhone,
  IsStrongPassword,
  Length,
  MaxLength,
  MinLength,
  IsEmail,
  IsString,
  IsNotEmpty,
  IsDateString,
  IsIn,
  IsNumberString,
} from 'class-validator';

/**
 * 전화번호 DTO
 * @public
 */
export class phoneDTO {
  @IsMobilePhone()
  phone!: string;
}

/**
 * 로그인 DTO
 * @public
 */
export class siginDTO extends phoneDTO {
  @IsStrongPassword({
    minLength: 4,
    minUppercase: 0,
    minLowercase: 0,
    minNumbers: 0,
    minSymbols: 0,
  })
  password!: string;
}

/**
 * 숫자 비밀번호 DTO
 * @public
 */
export class numberPasswordDTO {
  @MaxLength(6)
  @MinLength(6)
  @IsNumberString()
  @IsNotEmpty()
  password: string;
}

/**
 * 비밀번호 DTO
 * @public
 */
export class passwordDTO {
  @IsStrongPassword({
    minLength: 8,
    minUppercase: 0,
    minLowercase: 1,
    minNumbers: 1,
    minSymbols: 1,
  })
  @IsNotEmpty()
  password!: string;
}

/**
 * 디바이스 DTO
 * @public
 */
export class deviceDTO {
  @Length(2, 6)
  name!: string;
}

/**
 * 이메일 DTO
 * @public
 */
export class emailDTO {
  @IsEmail()
  email!: string;
}

/**
 * 인증 코드 DTO
 * @public
 */
export class authorDTO {
  @MaxLength(4)
  @MinLength(4)
  code!: string;
}

/**
 * 이름 DTO
 * @public
 */
export class nameDTO {
  @IsString()
  @IsNotEmpty()
  @MinLength(2)
  @MaxLength(100)
  name!: string;
}

/**
 * 센터 DTO
 * @public
 */
export class centerDTO {
  @IsString()
  @IsNotEmpty()
  @MaxLength(100)
  centerName!: string;
}

/**
 * 날짜 DTO
 * @public
 */
export class dateDTO {
  @IsDateString()
  birthDay: string;
}

/**
 * 성별 DTO (male:1 female:2 none:0)
 * @public
 */
export class genderDTO {
  @IsIn([0, 1, 2])
  gender!: number;
}

/**
 * 연도 날짜 DTO
 * @public
 */
export class yearDateDTO {
  @IsString()
  @MaxLength(4)
  birthDate!: string;
}
